const UserEnums = {
  ADMIN_ROLE: 'admin',
  USER_ROLE: 'user',
};

export const UserRoles = {
  ADMIN_ROLE: 'admin',
  USER_ROLE: 'user',
};

export const UserStatuses = [
  'active',
  'inactive',
  'banned',
];

export default UserEnums;
